import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import RouteFallback from "./components/RouteFallback";
import SiteJsonLd from "./components/SiteJsonLd";
import PluxChatWidget from "./components/PluxChatWidget";
import { SITE_REDIRECTS } from "./content";

import "./styles/index.css";

const About = lazy(() => import("./pages/About"));
const GetInTouch = lazy(() => import("./pages/GetInTouch"));
const Home = lazy(() => import("./pages/Home"));
const OurTeam = lazy(() => import("./pages/OurTeam"));
const Portfolio = lazy(() => import("./pages/Portfolio"));
const Portfolio1 = lazy(() => import("./pages/Portfolio1"));
const Portfolioprojects = lazy(() => import("./pages/portfolio/Portfolioprojects"));
const Magento2 = lazy(() => import("./pages/portfolio/Magento2"));
const Php = lazy(() => import("./pages/portfolio/Php"));
const Laravel = lazy(() => import("./pages/portfolio/Laravel"));
const Codeigniter = lazy(() => import("./pages/portfolio/Codeigniter"));
const Wordpress = lazy(() => import("./pages/portfolio/Wordpress"));
const Services = lazy(() => import("./pages/Services"));
const WebDevelopmentPage = lazy(() => import("./pages/WebDevelopment"));
const Webdesign = lazy(() => import("./pages/Webdesign"));
const MagentoDev = lazy(() => import("./pages/MagentoDev"));
const MobileApp = lazy(() => import("./pages/MobileApp"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogMainPage = lazy(() => import("./pages/BlogMainPage"));
const Career = lazy(() => import("./pages/Career"));
const AiAutomation = lazy(() => import("./pages/landing/AiAutomation"));
const WordpressDevelopment = lazy(() => import("./pages/landing/WordpressDevelopment"));
const WebsiteMaintenance = lazy(() => import("./pages/landing/WebsiteMaintenance"));
const EcommerceDevelopment = lazy(() => import("./pages/landing/EcommerceDevelopment"));
const MarketplaceCataloging = lazy(() => import("./pages/landing/MarketplaceCataloging"));
const EducationWebsiteDevelopment = lazy(() => import("./pages/landing/EducationWebsiteDevelopment"));
const ErpDevelopment = lazy(() => import("./pages/landing/ErpDevelopment"));
const FormCrmIntegrations = lazy(() => import("./pages/landing/FormCrmIntegrations"));
const EducationSearchPlatforms = lazy(() => import("./pages/landing/EducationSearchPlatforms"));
const WoocommercePaymentCrmIntegrations = lazy(() => import("./pages/landing/WoocommercePaymentCrmIntegrations"));
const AnalyticsTagManagement = lazy(() => import("./pages/landing/AnalyticsTagManagement"));
const PrivacyTranslationWidgets = lazy(() => import("./pages/landing/PrivacyTranslationWidgets"));
const NotFound = lazy(() => import("./pages/NotFound"));

export default function App() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ScrollToTop />
      <SiteJsonLd />
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Header />
      <main id="main-content" tabIndex={-1}>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            {SITE_REDIRECTS.map((redirect) => (
              <Route
                key={redirect.from}
                path={redirect.from}
                element={<Navigate to={redirect.to} replace />}
              />
            ))}

            <Route path="/ecommerce-development" element={<EcommerceDevelopment />} />

            <Route path="/web-development" element={<WebDevelopmentPage />} />

            <Route path="/website-maintenance" element={<WebsiteMaintenance />} />

            <Route path="/web-design" element={<Webdesign />} />

            <Route path="/wordpress-development" element={<WordpressDevelopment />} />
            <Route path="/ai-automation" element={<AiAutomation />} />
            <Route path="/marketplace-cataloging" element={<MarketplaceCataloging />} />
            <Route path="/education-website-development" element={<EducationWebsiteDevelopment />} />
            <Route path="/erp-development" element={<ErpDevelopment />} />
            <Route path="/form-crm-integrations" element={<FormCrmIntegrations />} />
            <Route path="/education-search-platforms" element={<EducationSearchPlatforms />} />
            <Route path="/woocommerce-payment-crm-integrations" element={<WoocommercePaymentCrmIntegrations />} />
            <Route path="/analytics-tag-management" element={<AnalyticsTagManagement />} />
            <Route path="/privacy-translation-widgets" element={<PrivacyTranslationWidgets />} />

            <Route path="/magento-development" element={<MagentoDev />} />

            <Route path="/mobile-app" element={<MobileApp />} />

            <Route path="/about" element={<About />} />

            <Route path="/services" element={<Services />} />

            <Route path="/portfolio" element={<Portfolio />} />

            <Route path="/portfolio/classic" element={<Portfolio1 />}>
              <Route index element={<Portfolioprojects />} />
              <Route path="magento2" element={<Magento2 />} />
              <Route path="php" element={<Php />} />
              <Route path="laravel" element={<Laravel />} />
              <Route path="codeigniter" element={<Codeigniter />} />
              <Route path="wordpress" element={<Wordpress />} />
            </Route>

            <Route path="/leadership" element={<OurTeam />} />

            <Route path="/getintouch" element={<GetInTouch />} />

            <Route path="/blog" element={<Blog />} />

            <Route path="/career" element={<Career />} />

            <Route path="/blogs/:slug" element={<BlogMainPage />} />

            <Route path="/" element={<Home />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
      <PluxChatWidget site="plux" title="Chat with Sia" />
    </BrowserRouter>
  );
}
